import React from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import { useBack } from '../hooks/useBack'

const Container = styled.div`
  text-align: left;
  padding: 20px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.text.normal};

  h1 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  h2 {
    font-size: 16px;
    font-weight: 600;
    margin: 24px 0 12px;
  }

  h3 {
    font-size: 14px;
    font-weight: 600;
    margin: 16px 0 8px;
  }

  p {
    font-size: 14px;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 18px;
    margin-bottom: 12px;
    list-style: disc;
  }

  ol {
   padding-left: 22px;
   margin-bottom: 12px;
    list-style: decimal;
  }

  li {
    font-size: 14px;
    margin-bottom: 6px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    font-size: 13px;
  }

  th, td {
    border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
    padding: 8px;
    text-align: left;
  }

  th {
    background: ${({ theme }) => theme.colors.neutral[100]};
    font-weight: 600;
  }

`;

const TermsType = () => {
  const { type } = useParams();
  const [content, setContent] = useState('')
  const goBack = useBack(); // 뒤로가기 훅 호출

  useEffect(() => {
    fetch(`/assets/terms/${type}.md`)
      .then(res => res.text())
      .then(setContent)
  }, [type])

  return (
    <DefaultLayout
      headerType="sub"
      onBack={goBack}>
      <Container>
        <ReactMarkdown 
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw]}>
          {content}
        </ReactMarkdown>
      </Container>
    </DefaultLayout>
  )
}

export default TermsType
